import * as api from '../Firebase/apiProjects'
import { accountInfoReceive } from './account'
import { settingsReceive } from './tableLayout'
import { userTagsReceive } from './tagList'
import { printOptionsReceive } from './printOptions'
import { onAccountRegDataChanged } from './account'
import objPropCount from '../utils/objectPropertiesCount'

const PROJECT_LIST_INIT = 'PROJECT_LIST_INIT'
const PROJECT_CHB_CHANGED = 'PROJECT_CHB_CHANGED'
const PROJECT_ADD = 'PROJECT_ADD'
const PROJECT_RENAME = 'PROJECT_RENAME'
const PROJECT_DELETE = 'PROJECT_DELETE'
const PROJECT_SELECTIONS = 'PROJECT_SELECTIONS'
const MOYSET_LIST_CHANGED = 'MOYSET_LIST_CHANGED'

export const getProjectList = () => {
  return (dispatch) => {
    api.getProjectList(dispatch, projectListReceive)
  }
}

const projectListReceive = data => {
  return dispatch => {
    dispatch(accountInfoReceive(data.account))
    dispatch(onProjectListReceive(data.projects))
    if (data.regData) {
      dispatch(onAccountRegDataChanged(data.regData))
    }
    if (data.settings) {
      dispatch(settingsReceive(data.settings))
    }
    if (data.tags) {
      dispatch(userTagsReceive(data.tags))
    }
    if (data.printOptions) {
      dispatch(printOptionsReceive(data.printOptions))
    }
  }
}

export const onProjectListReceive = data => {
  return {
    type: PROJECT_LIST_INIT,
    data: data
  }
}

export const addProject = (name) => {
  return (dispatch) => {
    api.addProject(name, dispatch, onProjectAdd)
  }
}

const onProjectAdd = (key, name) => {
  return {
    type: PROJECT_ADD,
    key: key,
    name: name
  }
}

export const renameProject = () => {
  return (dispatch, getState) => {
    const projects = getState().projectList.projects
    for (let pid in projects) {
      if(projects.hasOwnProperty(pid) && projects[pid].s) {
        const name = prompt('Zadejte nové jméno akce:', projects[pid].n)
        if (name) {
          api.renameProject(pid, name, dispatch, onProjectRename)
        }
        return
      }
    }
  }
}

const onProjectRename = (pid, name) => {
  return {
    type: PROJECT_RENAME,
    pid: pid,
    name: name
  }
}

export const deleteProjects = () => {
  return (dispatch, getState) => {
    const projects = getState().projectList.projects
    const c = getState().projectList.selectedCount
    if (!window.confirm(c === 1 ? 'Smazat vybranou akci?' : 'Smazat vybrané akce?')) {
        return
    }
    let deletedPids = []
    for (let pid in projects) {
      if(projects.hasOwnProperty(pid) && projects[pid].s) {
        deletedPids.push(pid)
      }
    }
    api.deleteProjects(deletedPids, dispatch, onProjectDelete)
  }
}

const onProjectDelete = (pids) => {
  return {
    type: PROJECT_DELETE,
    pids: pids
  }
}

export const onProjectChbChanged = (i) => {
  return {
    type: PROJECT_CHB_CHANGED,
    index: i
  }
}

export const onProjectSelections = (select) => {
  return {
    type: PROJECT_SELECTIONS,
    select: select
  }
}

export const saveMoySet = (moySet, projectId, operation) => {
  return (dispatch) => {
    api.saveMoySet(dispatch, onMoySeListChanged, moySet, projectId, operation)
  }
}

export const onMoySeListChanged = (moySet, projectId, operation) => {
  return {
    type: MOYSET_LIST_CHANGED,
    moySet: moySet,
    projectId: projectId,
    operation: operation
  }
}

const initState = {
  projects: {},
  selectedCount: 0
}

export default (state = initState, action) => {
  let newState
  switch (action.type) {
    case PROJECT_LIST_INIT:
      if (!action.data) {
        return { projects: undefined}
      }
      let projects = {}
      for (let key in action.data) {
        const n = action.data[key].name || action.data[key]
        projects[key] = {
          n: n,
          moy: action.data[key].moy || {},
          s: false }
      }
      return Object.assign({}, state, {
        projects: projects
      })
    case PROJECT_CHB_CHANGED:
      const proj = state.projects[action.index]
      const cc = state.selectedCount
      return Object.assign({}, state, {
        projects: {
          ...state.projects,
          [action.index]: {
            n: proj.n,
            s: !proj.s
          }
        },
        selectedCount: proj.s ? cc - 1 : cc + 1
      })
    case PROJECT_ADD:
      return Object.assign({}, state, {
          projects: {
            ...state.projects,
            [action.key]: {
              n: action.name,
              s: false
            }
          }
      })
    case PROJECT_RENAME:
      return Object.assign({}, state, {
        projects: {
          ...state.projects,
          [action.pid]: {
            n: action.name,
            s: false
          }},
          selectedCount: state.selectedCount - 1
      })
    case PROJECT_DELETE:
      let newProjects = Object.assign({}, state.projects)
      let sc = state.selectedCount
      for (let pid in action.pids) {
        delete newProjects[action.pids[pid]]
        sc--
      }
      return Object.assign({}, state, {
        projects: objPropCount(newProjects) !== 0 ? newProjects : -1,
        selectedCount: sc
      })
    case PROJECT_SELECTIONS:
      newState = Object.assign({}, state)
      let c = 0
      for (let p in state.projects) {
        if (state.projects.hasOwnProperty(p)) {
          newState.projects[p].s = action.select
          if (action.select) {
            c++
          }
        }
      }
      newState.selectedCount = c
      return newState
    case MOYSET_LIST_CHANGED:
      newState = Object.assign({}, state)
      newState.projects[action.projectId].moy[action.operation] = action.moySet
      return newState
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/projectList.js